// import CardContainer from "../../../components/card_container";
import { useState, useEffect } from "react";
import InputSwitch from "../../../components/input_switch";
import "../appearance/style.scss";
import useAppearance from "../../../hooks/settings/useAppearance";
import Toastify from "toastify-js";

const SetAppearancePage = () => {

    // const token = localStorage.getItem("token") || "";
    const {
        appearance,
        isLoading,
        error,
        refetch,
        toggleSection
    } = useAppearance();

    const [localAppearance, setLocalAppearance] = useState(appearance);
    const [updatingId, setUpdatingId] = useState(null);
    const [notification, setNotification] = useState({ type: '', message: '' });

    // Sync local state dengan hook state
    useEffect(() => {
        setLocalAppearance(appearance);
    }, [appearance]);

    // Reset notification
    useEffect(() => {
        if (notification.message) {
            const timer = setTimeout(() => {
                setNotification({ type: '', message: '' });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [notification]);

    const showToast = (text, type = "success") => {
        Toastify({
            text,
            duration: 3000,
            gravity: "top",
            position: "right",
            close: true,
            stopOnFocus: true,
            style: {
                background:
                    type === "success"
                        ? "black"
                        : "black",
            },
        }).showToast();
    };

    const handleToggle = async (sectionId) => {
        
        // if (!token || updatingId) return;
        
        const currentValue = localAppearance[sectionId];
        const newValue = !currentValue;

        const SECTION_LABELS = {
            hero: "Hero Section",
            howItWorks: "How It Works",
            ourProduct: "Our Products",
            customerReviews: "Customer Reviews",
            ourClients: "Our Clients",
            subsNewsletter: "Subscribe Newsletter",
            socialMedia: "Social Media",
            allProductSitemap: "All Products Site Map",
        };

        const name_sections = SECTION_LABELS[sectionId] || sectionId;

        try {
            
            setUpdatingId(sectionId);

            setLocalAppearance(prev => ({
                ...prev,
                [sectionId]: newValue
            }));

            const result = await toggleSection(sectionId, newValue);
            
            if (result.success) {
                showToast(`${name_sections} updated successfully`);
            } else {
                setLocalAppearance(prev => ({
                    ...prev,
                    [sectionId]: currentValue
                }));
                showToast(result.message || "Update failed", "error");
            }
        } catch (err) {
            
            setLocalAppearance(prev => ({
                ...prev,
                [sectionId]: currentValue
            }));
            showToast("Unexpected error occurred", "error");
        } finally {
            
            setUpdatingId(null);
        }
    };

    // Loading state
    if (isLoading) {
        return (
            <div className="features-list">
                <div className="loading-state">
                    <div className="spinner"></div>
                    <p>Loading appearance settings...</p>
                </div>
            </div>
        );
    }

    // Error state
    if (error) {
        return (
            <div className="features-list">
                <div className="error-state">
                    <p className="error-message">Error: {error}</p>
                    <button className="retry-btn" onClick={refetch}>
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="features-list">
            <div className="feature-item main-feature">
                <div className="feature-header">
                    <div className="feature-info" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                        <h2 className="feature-title">Appearance</h2>
                        <p className="feature-description" style={{ color: "#999999", fontSize: "14px" }}>Change how your website looks and feels.</p>
                    </div>
                </div>
            </div>


            {/* Dashboard */}
            <div className="feature-item main-feature">
                <div className="feature-header">
                    <div className="feature-info">
                        <h4 className="feature-title">Hero Section</h4>
                    </div>
                    <InputSwitch
                        id="hero"
                        isOn={appearance.hero ?? false}
                        disabled={updatingId === "hero"}
                        onClick={() => handleToggle("hero")}
                    />
                </div>
            </div>

            <div className="feature-item main-feature">
                <div className="feature-header">
                    <div className="feature-info">
                        <h4 className="feature-title">How It Works</h4>
                        {/* <p className="feature-description">Manage fabric inventory and details</p> */}
                    </div>
                    <InputSwitch
                        id="howItWorks"
                        label=""
                        isOn={appearance.howItWorks ?? true}
                        disabled={updatingId === "howItWorks"}
                        onClick={() => handleToggle("howItWorks")}
                    />
                </div>
            </div>

            <div className="feature-item main-feature">
                <div className="feature-header">
                    <div className="feature-info">
                        <h4 className="feature-title">Our Products</h4>
                    </div>
                    <InputSwitch
                        id="ourProduct"
                        label=""
                        isOn={appearance.ourProduct ?? true}
                        disabled={updatingId === "ourProduct"}
                        onClick={() => handleToggle("ourProduct")}
                    />
                </div>
            </div>

            <div className="feature-item main-feature">
                <div className="feature-header">
                    <div className="feature-info">
                        <h4 className="feature-title">Customer Reviews</h4>
                    </div>
                    <InputSwitch
                        id="customerReviews"
                        label=""
                        isOn={appearance.customerReviews ?? true}
                        disabled={updatingId === "customerReviews"}
                        onClick={() => handleToggle("customerReviews")}
                    />
                </div>
            </div>

            {/* Our Clients */}
            <div className="feature-item main-feature">
                <div className="feature-header">
                    <div className="feature-info">
                        <h4 className="feature-title">Our Clients</h4>
                    </div>
                    <InputSwitch
                        id="ourClients"
                        label=""
                        isOn={appearance.ourClients ?? true}
                        disabled={updatingId === "ourClients"}
                        onClick={() => handleToggle("ourClients")}
                    />
                </div>
            </div>

            {/* Subscribe Newsletter */}
            <div className="feature-item main-feature">
                <div className="feature-header">
                    <div className="feature-info">
                        <h4 className="feature-title">Subscribe Newsletter</h4>
                    </div>
                    <InputSwitch
                        id="subsNewsletter"
                        label=""
                        isOn={appearance.subsNewsletter ?? true}
                        disabled={updatingId === "subsNewsletter"}
                        onClick={() => handleToggle("subsNewsletter")}
                    />
                </div>
            </div>

            <div className="feature-item main-feature">
                <div className="feature-header">
                    <div className="feature-info">
                        <h4 className="feature-title">Social Media</h4>
                    </div>
                    <InputSwitch
                        id="socialMedia"
                        label=""
                        isOn={appearance.socialMedia ?? true}
                        disabled={updatingId === "socialMedia"}
                        onClick={() => handleToggle("socialMedia")}
                    />
                </div>
            </div>

            <div className="feature-item main-feature">
                <div className="feature-header">
                    <div className="feature-info">
                        <h4 className="feature-title">All Products Site Map</h4>
                    </div>
                    {/* <InputSwitch
                        id="allProductSitemap"
                        label=""
                        isOn={appearance.allProductSitemap ?? true}
                        disabled={updating || true} // Disable jika diperlukan
                        onClick={(value) => handleToggle("allProductSitemap", value)}
                    /> */}
                </div>


            </div>
        </div>
    );
}

export default SetAppearancePage;